var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tags"},_vm._l((_vm.tags),function(t){return _c('el-tag',{key:t,attrs:{"type":t === '待发货' ? 'danger' : 'success',"disable-transitions":""}},[_vm._v(" "+_vm._s(t)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }